<template>
  <div class="tcla-irrelevant-links">
    <div class="tcla-panel">
      <h3 class="tcla-panel__title tcla-section__title--err">🚫 لینک‌های داخلی بی‌ربط</h3>
      <p class="tcla-panel__hint">
        این‌ها لینک‌های داخلی موجودی هستند که به صفحه‌ای بدون ربط موضوعی اشاره می‌کنند
        — هم بر اساس شباهت معنایی پایین و هم نبود دسته/برچسب مشترک تشخیص داده شده‌اند
        (فقط وقتی هر دو سیگنال با هم موافق باشند پرچم می‌خورد، تا هشدار اشتباه کم شود).
        این نوع لینک‌ها اعتبار لینک را هدر می‌دهند و برای گوگل سیگنال گیج‌کننده می‌فرستند.
      </p>
      <div v-if="irrelevantLinks.length === 0" class="tcla-empty">
        هیچ لینک بی‌ربطی پیدا نشد 🎉
      </div>
      <div v-for="(link, idx) in irrelevantLinks" :key="idx" class="tcla-link-card">
        <div class="tcla-link-card__head">
          <div class="tcla-link-card__titles">
            <strong>{{ link.sourceTitle }}</strong>
            <span class="tcla-arrow">→</span>
            <strong>{{ link.targetTitle }}</strong>
          </div>
          <span
            class="tcla-tag"
            :class="link.confidence === 'high' ? 'tcla-tag--err' : 'tcla-tag--warn'"
          >
            {{ link.confidence === 'high' ? '🔴 قطعی' : '🟡 احتمالی' }}
          </span>
        </div>
        <div class="tcla-link-card__meta">
          <span v-if="link.anchorText">انکرتکست: «{{ link.anchorText }}»</span>
          <span v-if="link.similarity !== null"> · شباهت معنایی: {{ link.similarity }}٪</span>
        </div>
        <div class="tcla-link-card__reason">💡 {{ link.reason }}</div>
        <div class="tcla-link-card__footer">
          <button class="tcla-btn" @click="$emit('edit-blog', getSource(link.sourceUrl))">ویرایش مقاله مبدأ</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TCLAIrrelevantLinks',
  props: {
    irrelevantLinks: { type: Array, default: () => [] },
    graph: { type: Object, default: () => ({ nodes: {} }) }
  },
  methods: {
    getSource(url) {
      return this.graph.nodes[url] ? this.graph.nodes[url].source : null;
    }
  }
};
</script>

<style scoped>
.tcla-panel {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 0.75rem;
  padding: 20px;
}

.tcla-panel__title { font-size: 0.95rem; font-weight: 700; margin: 0 0 8px 0; }
.tcla-section__title--err { color: #ef4444; }
.tcla-panel__hint {
  font-size: 0.78rem;
  color: #9ca3af;
  line-height: 1.6;
  margin: 0 0 16px 0;
  padding-bottom: 12px;
  border-bottom: 1px solid #f3f4f6;
}
.tcla-empty { text-align: center; padding: 20px; color: #9ca3af; }

.tcla-link-card {
  border: 1px solid #fecaca;
  background: #fef2f2;
  border-radius: 0.5rem;
  padding: 14px;
  margin-bottom: 12px;
}

.tcla-link-card__head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 6px;
}

.tcla-link-card__titles {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.88rem;
  flex-wrap: wrap;
}
.tcla-arrow { color: #ef4444; }

.tcla-link-card__meta {
  font-size: 0.78rem;
  color: #7f1d1d;
  margin-bottom: 6px;
}

.tcla-link-card__reason {
  font-size: 0.8rem;
  color: #991b1b;
  background: #fee2e2;
  padding: 8px;
  border-radius: 0.375rem;
  margin-bottom: 10px;
}

.tcla-link-card__footer { display: flex; justify-content: flex-end; }

.tcla-tag {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 100px;
  font-size: 0.72rem;
  font-weight: 700;
  flex-shrink: 0;
}
.tcla-tag--err { background: #fee2e2; color: #dc2626; }
.tcla-tag--warn { background: #fef3c7; color: #d97706; }

.tcla-btn {
  padding: 6px 12px;
  background: #fff;
  border: 1px solid #fecaca;
  border-radius: 0.375rem;
  font-size: 0.8rem;
  cursor: pointer;
  color: #991b1b;
}
.tcla-btn:hover { background: #fef2f2; }
</style>
